<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-card>
      <!--Fixme 固定高度在vutify@1.4中已经不可用，会造成父级元素（v-card-title）塌陷-->
      <v-card-title class="py-0 my-0" style="height: 80px">
        <span v-if="data.obgrp.status === '-1'" class="title" style="color: red"
          >【失效】</span
        >
        <span :class="data.name ? '' : 'grey--text'" class="title px-2">{{
          data.obgrp.name || "分组名称"
        }}</span>
        <slot name="time">
          <v-layout class="pl-2" wrap>
            <v-flex xs4 class="mr-2">
              <span class="grey--text caption mr-2">上次更新</span>
              <span
                :class="data.lastUpdateTime ? '' : 'grey--text'"
                class="pr-4"
                >{{
                  $L.time.stringify(data.obgrp.lastUpdateTime) || "N/A"
                }}</span
              >
            </v-flex>
            <v-flex xs4 class="mr-2">
              <span class="grey--text caption mr-2">创建时间</span>
              <span
                :class="data.creationTime ? '' : 'grey--text'"
                class="pr-4"
                >{{ $L.time.stringify(data.obgrp.creationTime) || "N/A" }}</span
              >
            </v-flex>
            <v-flex xs4>
              <span class="grey--text caption mr-2">过期时间</span>
              <span
                :class="data.expirationTime ? '' : 'grey--text'"
                class="pr-4"
                >{{
                  $L.time.stringify(data.obgrp.expirationTime) || "N/A"
                }}</span
              >
            </v-flex>
          </v-layout>
        </slot>
        <v-spacer></v-spacer>
        <slot name="title-actions"></slot>
      </v-card-title>
      <v-tabs grow v-model="tab">
        <v-tab key="info">分组信息</v-tab>
        <v-tab key="vehicle">车辆管理</v-tab>
        <v-tab key="rule">分组规则</v-tab>
        <v-tab key="specific">特殊规则</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="info">
          <v-card-text>
            <v-container class="pb-0" fluid grid-list-md>
              <v-layout v-if="!data.editInfo" wrap>
                <v-flex :class="opt.layout" :key="i" v-for="(opt, i) in opts">
                  <info-cell
                    v-bind="opt"
                    v-model="data.obgrp[opt.key]"
                  ></info-cell>
                </v-flex>
              </v-layout>
              <v-layout v-else wrap>
                <v-flex
                  :class="opt.layout"
                  :key="i"
                  v-for="(opt, i) in formDefine"
                >
                  <l-input :config="opt" v-model="infoForm[opt.key]"></l-input>
                </v-flex>
              </v-layout>
              <v-layout
                justify-center
                column
                v-if="selfSignInfo.selfSignUrl !== ''"
              >
                <h3 class="pl-4 ml-2">自助预约二维码</h3>
                <v-layout>
                  <v-flex xs2>
                    <img
                      :src="selfSignInfo.selfSignUrl"
                      style="width: 200px; height: 200px"
                    />
                  </v-flex>
                  <v-flex xs3 class="ml-2 mt-5 pt-4">
                    <v-layout column>
                      <v-flex xs6>
                        <v-text-field
                          label="自助预约总数"
                          v-model="selfSignInfo.total"
                          prepend-icon="$vuetify.icons.code"
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          label="每天预约数目"
                          v-model="selfSignInfo.perDay"
                          prepend-icon="$vuetify.icons.code"
                          disabled
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="goEditInfo"
              color="primary"
              flat
              large
              v-if="!data.editInfo"
              :disabled="!(data.obgrp.status === '1')"
              >编辑</v-btn
            >
            <v-btn
              @click="goReadonly"
              color="grey"
              flat
              large
              v-if="data.editInfo"
              >取消</v-btn
            >
            <v-btn
              :loading="data.loading"
              @click="setGroupInfo"
              color="primary"
              flat
              large
              v-if="data.editInfo"
              >提交
            </v-btn>
          </v-card-actions>
        </v-tab-item>
        <v-tab-item key="vehicle">
          <v-card>
            <l-data-table
              :get-data-func="getVehicles"
              :headers="vehicleHeaders"
              :filter-items="filter"
              flat
              selectable
              title-text="分组车辆列表"
              @click:row="goDetails($event.item)"
              clickable
              ref="vehicleTable"
            >
              <!--<template slot="title">-->
              <!--<v-btn class="mx-0" color="primary" flat>添加车辆</v-btn>-->
              <!--<v-btn class="mx-0" color="primary" flat>批量添加</v-btn>-->
              <!--</template>-->
              <!--<template slot="row-action" slot-scope="{item}">-->
              <!--<td @click.stop class="mx-0 px-0 text-xs-center">-->
              <!--<v-btn icon>-->
              <!--<v-icon small>$vuetify.icons.more</v-icon>-->
              <!--</v-btn>-->
              <!--</td>-->
              <!--</template>-->
              <template slot="row-action" slot-scope="{ item }">
                <td @click.stop>
                  <v-btn
                    @click="deleteVehicle(item)"
                    icon
                    :disabled="item.status === '-1'"
                  >
                    <v-icon>$vuetify.icons.delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </l-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item key="rule" style="min-height: 300px">
          <v-layout class="py-2" wrap>
            <v-flex xs12>
              <v-layout column>
                <p class="pl-4 mt-3">有效规则</p>
                <l-pass-rule-list :pass-rules="passRules">
                  <div @click.stop slot="action" slot-scope="{ item, index }">
                    <l-option-menu
                      :options="options"
                      @delete="deletePassRule(item)"
                      @edit="openSetRuleDialog('edit', item, index)"
                    >
                      <v-btn icon slot="activator" small>
                        <v-icon small>$vuetify.icons.more</v-icon>
                      </v-btn>
                    </l-option-menu>
                  </div>
                </l-pass-rule-list>
              </v-layout>
            </v-flex>
            <v-flex class="px-2" xs12>
              <v-btn
                @click="openSetRuleDialog('new', null, data.rules.length)"
                color="primary"
                flat
                >添加规则</v-btn
              >
            </v-flex>
            <v-flex xs12>
              <v-layout column>
                <v-divider></v-divider>
                <p class="pl-4 mt-3">失效规则</p>
                <l-pass-rule-list :pass-rules="passFairRules">
                </l-pass-rule-list>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item key="specific" style="min-height: 300px">
          <v-layout class="py-2" wrap>
            <v-layout ml-4>
              <v-flex xs4>
                <v-text-field
                  v-model="search"
                  hint="输入想查询的车牌号"
                  label="车牌号"
                ></v-text-field>
              </v-flex>
              <v-btn class="primary" @click="getSpecifics(true)">查询</v-btn>
            </v-layout>
            <v-flex xs12>
              <l-pass-rule-list :pass-rules="specificalRules" specific>
                <div @click.stop slot="action" slot-scope="{ item, index }">
                  <!-- <l-option-menu
                    :options="options"
                    @delete="deleteSpecific(item)"
                    @edit="openSetSpecificDialog('edit',item, index)">
                    <v-btn icon slot="activator" small>
                      <v-icon small>$vuetify.icons.more</v-icon>
                    </v-btn>
                  </l-option-menu>-->
                  <v-menu left>
                    <v-btn slot="activator" icon small>
                      <v-icon small>$vuetify.icons.more</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile
                        @click="openSetSpecificDialog('edit', item, index)"
                        :disabled="data.obgrp.status !== '1'"
                      >
                        <v-list-tile-avatar>
                          <v-icon small>{{ $vuetify.icons.edit }}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title class="pr-1">
                          编辑
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="deleteSpecific(item)"
                        :disabled="data.obgrp.status !== '1'"
                      >
                        <v-list-tile-avatar>
                          <v-icon small>{{ $vuetify.icons.delete }}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title class="pr-1">
                          删除
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </l-pass-rule-list>
            </v-flex>
            <v-flex v-if="specificalRules.length !== 0">
              <div class="text-xs-center">
                <v-pagination v-model="page" :length="totalPage"></v-pagination>
              </div>
            </v-flex>

            <v-flex class="px-2" xs12>
              <v-btn
                @click="
                  openSetSpecificDialog('new', null, data.specifics.length)
                "
                :disabled="data.obgrp.status !== '1'"
                color="primary"
                flat
                >添加规则
              </v-btn>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
      <l-fixed-btn
        v-if="tab === 1 && data.obgrp.status === '1'"
        @click="addVehicle"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
    <v-dialog
      max-width="900px"
      persistent
      scrollable
      v-model="passRuleDialog.activate"
    >
      <set-pass-rule-content
        :authority="authority"
        :params="{ index: passRuleDialog.index, type: authority.name }"
        :rule="passRuleDialog.item"
        :status="passRuleDialog.status"
        @cancel="closeSetRuleDialog"
        @save="setPassRule($event.newItem)"
        ref="ruleContent"
        v-if="passRuleDialog.activate"
      ></set-pass-rule-content>
    </v-dialog>
    <v-dialog
      max-width="900px"
      persistent
      scrollable
      v-model="specificRuleDialog.activate"
    >
      <set-pass-rule-content
        :authority="authority"
        :params="{ index: specificRuleDialog.index, type: '特殊规则' }"
        :rule="specificRuleDialog.item"
        :status="specificRuleDialog.status"
        @cancel="closeSetSpecificDialog"
        @save="setSpecificRule($event.newItem)"
        ref="specificContent"
        v-if="specificRuleDialog.activate"
      >
        <template slot="append" slot-scope="{ newItem, status }">
          <v-subheader class="mx-0">车辆信息</v-subheader>
          <v-layout wrap class="mb-4">
            <v-flex xs12>
              <l-autocomplete
                :disabled="status === 'edit'"
                label="车辆号牌"
                :get-data="findVehicleInGroup"
                item-text="plate"
                prepend-icon="$vuetify.icons.car"
                v-model="newItem.vehicle"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-switch
                label="单独执行"
                v-model="newItem.isStandalone"
              ></v-switch>
            </v-flex>
          </v-layout>
        </template>
      </set-pass-rule-content>
    </v-dialog>
    <v-dialog v-model="deleteFailDialog.activated" width="500">
      <v-layout column>
        <v-card>
          <v-card-title style="height: 64px">
            <span class="title">删除车辆失败</span>
          </v-card-title>
          <v-card-text style="min-height: 350px; max-height: 500px">
            <div class="mb-4">
              <div class="subheading py-2">
                以下车辆删除失败,是否选择强制删除？
              </div>
              <!--<v-divider></v-divider>-->
              <l-data-table
                :headers="deleteFailHeader"
                :init-pagination="{ rowsPerPage: 5 }"
                :items="deleteFailArrItems"
                auto-actions
                hide-headers
                hide-title
                flat
              ></l-data-table>
            </div>
            <v-layout justify-center>
              <v-btn
                class="primary"
                @click="deleteVehicleForce"
                :loading="deleteFailDialog.loading"
                >确定</v-btn
              >
              <v-btn class="error" @click="deleteFailDialog.activated = false"
                >取消</v-btn
              >
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
import LPassRuleList from "../../../components/LPassRuleList";
import InfoCell from "../../../components/infoCell";
import {
  ReservationGroup,
  ReservationAuthority,
  SpecificRule,
} from "../../../object";
import {
  RULE_ACTION_HEADERS,
  SPECIFIC_ACTION_HEADERS,
} from "../../../consts/pass";
import { passRule } from "@/mixins";
import SetPassRuleContent from "../../../components/SetPassRuleContent";
import { GROUP_VEHICLE_HEADER } from "@/consts/reservation";
import { time, F } from "../../../ladmin/utils";
export default {
  name: "ReservationGroupDetails",
  components: { SetPassRuleContent, InfoCell, LPassRuleList },
  mixins: [passRule],
  props: {
    data: {
      type: Object,
      required: true,
    },
    reservationStatus: {
      type: String,
      default: "1",
    },
    tabProp: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalPage: 1,
      search: "",
      /* 过期标志 */
      overdateFlag: false,
      selfSignInfo: {
        selfSignUrl: "",
        total: "",
        perDay: "",
        comment: "",
      },
      passRules: [],
      passFairRules: [],
      specificalRules: [],
      specificRuleDialog: {
        activate: false,
        item: {},
        index: 0,
        status: 0,
      },
      userSelect: [],
      infoForm: {},
      tab: 0,
      vehicleHeaders: [
        { text: "车辆号牌", value: "plate", align: "left", placeholder: "N/A" },
        {
          text: "访客手机",
          value: "phone",
          align: "right",
          placeholder: "N/A",
          sortable: false,
        },
        {
          text: "访客姓名",
          value: "name",
          align: "right",
          placeholder: "N/A",
          sortable: false,
        },
        {
          text: "开始时间",
          value: "startDatetime",
          align: "right",
          placeholder: "N/A",
          f: (v) => time.stringify(v),
        },
        {
          text: "结束时间",
          value: "endDatetime",
          align: "right",
          placeholder: "N/A",
          f: (v) => time.stringify(v),
        },
        {
          text: "是否有效",
          value: "status",
          align: "left",
          placeholder: "N/A",
          f: (v) => (v === "1" ? "有效" : "失效"),
        },
        { text: "", value: "", sortable: false },
      ],
      ruleHeaders: RULE_ACTION_HEADERS,
      specificHeaders: SPECIFIC_ACTION_HEADERS,
      rules: [],
      specifics: [],
      options: [
        {
          event: "edit",
          icon: "$vuetify.icons.edit",
          label: "编辑",
        },
        {
          event: "delete",
          icon: "$vuetify.icons.delete",
          label: "删除",
        },
      ],
      opts: [
        {
          key: "name",
          label: "分组名称",
          layout: ["xs12"],
          icon: "$vuetify.icons.group",
        },
        {
          key: "description",
          label: "分组描述",
          layout: ["xs12"],
          textarea: true,
          icon: "$vuetify.icons.description",
        },
        {
          key: "priority",
          label: "优先级别",
          layout: ["xs12"],
          icon: "$vuetify.icons.level",
        },
        /* {
          key: 'expirationTime',
          label: '过期时间',
          layout: ['xs12', 'sm6'],
          icon: '$vuetify.icons.datetime'
        }, */
        {
          key: "osdMsgIn",
          label: "进场屏显提示",
          layout: ["xs12"],
          textarea: true,
          icon: "$vuetify.icons.led",
        },
        {
          key: "vcbMsgIn",
          label: "进场语音提示",
          layout: ["xs12"],
          textarea: true,
          icon: "$vuetify.icons.audio",
        },
        {
          key: "osdMsgOut",
          label: "出场屏显提示",
          layout: ["xs12"],
          textarea: true,
          icon: "$vuetify.icons.led",
        },
        {
          key: "vcbMsgOut",
          label: "出场语音提示",
          layout: ["xs12"],
          textarea: true,
          icon: "$vuetify.icons.audio",
        },
      ],
      formDefine: [
        {
          type: "input",
          key: "name",
          label: "分组名称",
          layout: ["xs12"],
          prependIcon: "$vuetify.icons.group",
        },
        {
          type: "input",
          key: "description",
          label: "分组描述",
          layout: ["xs12"],
          prependIcon: "$vuetify.icons.description",
        },
        {
          type: "input",
          key: "priority",
          label: "优先级别",
          layout: ["xs12"],
          prependIcon: "$vuetify.icons.level",
        },
        /*        {
          type: 'datetime',
          key: 'expirationTime',
          label: '过期时间',
          layout: ['xs12', 'sm6']
        }, */
        {
          rows: 1,
          autoGrow: true,
          type: "textarea",
          key: "ledPromptIn",
          label: "进场屏显提示",
          layout: ["xs12"],
          prependIcon: "$vuetify.icons.led",
        },
        {
          rows: 1,
          autoGrow: true,
          type: "textarea",
          key: "audioPromptIn",
          label: "进场语音提示",
          layout: ["xs12"],
          prependIcon: "$vuetify.icons.audio",
        },
        {
          rows: 1,
          autoGrow: true,
          type: "textarea",
          key: "ledPromptOut",
          label: "出场屏显提示",
          layout: ["xs12"],
          prependIcon: "$vuetify.icons.led",
        },
        {
          rows: 1,
          autoGrow: true,
          type: "textarea",
          key: "audioPromptOut",
          label: "出场语音提示",
          layout: ["xs12"],
          prependIcon: "$vuetify.icons.audio",
        },
      ],
      filter: [
        {
          prependIcon: "$vuetify.icons.edit",
          key: "status",
          value: this.data.obgrp.rhdata,
          label: "是否有效",
          type: "select",
          layout: ["xs12", "sm4"],
          items: [
            {
              value: "",
              text: "全部",
            },
            {
              value: '{"r_h_status":"1"}',
              text: "有效",
            },
            {
              value: '{"r_h_status":"-1"}',
              text: "失效",
            },
          ],
        },
        {
          label: "开始时间",
          layout: "xs12, sm4",
          type: "duration",
          key: "startDatetime",
          value: {},
          range: true,
          f: (v) => {
            if (!v.startDatetime && !v.endDatetime) {
              return null;
            } else {
              let s = time.toTimeStamp(v.startDatetime) || 0;
              let e = time.toTimeStamp(v.endDatetime) || 9999999999999;
              return [s, e];
            }
          },
        },
        {
          label: "截止时间",
          layout: "xs12, sm4",
          type: "duration",
          key: "endDatetime",
          value: {},
          range: true,
          f: (v) => {
            if (!v.startDatetime && !v.endDatetime) {
              return null;
            } else {
              let s = time.toTimeStamp(v.startDatetime) || 0;
              let e = time.toTimeStamp(v.endDatetime) || 9999999999999;
              return [s, e];
            }
          },
        },
        {
          prependIcon: "$vuetify.icons.phone",
          key: "visitorPhone",
          value: "",
          label: "联系电话",
          type: "input",
          layout: ["xs12", "sm4"],
        },
      ],
      deleteFailArr: [],
      deleteFailArrItems: [],
      deleteFailDialog: {
        activated: false,
        loading: false,
      },
      deleteFailHeader: [
        { text: "车牌号", value: "plate", sortable: false, align: "left" },
      ],
    };
  },
  computed: {
    authority() {
      let auth = this.$store.state.reservation.adminAuth;
      auth.editPrompt = false;
      return auth;
    },
  },
  watch: {
    tab() {
      this.$emit("changeTab", this.tab);
    },
    page() {
      this.getSpecifics();
    },
  },
  methods: {
    goEditInfo() {
      this.infoForm = new ReservationGroup(this.data.obgrp);
      this.infoForm.ledPromptIn = this.data.obgrp.osdMsgIn;
      this.infoForm.ledPromptOut = this.data.obgrp.osdMsgOut;
      this.infoForm.audioPromptIn = this.data.obgrp.vcbMsgIn;
      this.infoForm.audioPromptOut = this.data.obgrp.vcbMsgOut;
      this.data.editInfo = true;
    },
    goReadonly() {
      this.data.editInfo = false;
    },
    async setGroupInfo() {
      try {
        this.$set(this.data.obgrp, "loading", true);
        let g = await this.$store.dispatch(
          "reservation/setReservationGroup",
          this.infoForm
        );
        this.$emit("refresh");
        /*      let keys = [
                'name',
                'description',
                'priority',
                'expirationTime',
                'ledPromptIn',
                'audioPromptIn',
                'ledPromptOut',
                'audioPromptOut',
              ]
              for (let key of keys) {
                this.$set(this.data.obgrp, key, g[key])
              } */
        /* this.goReadonly() */
      } catch (e) {
        this.$L.alert("error", e.message);
      } finally {
        this.$set(this.data.obgrp, "loading", false);
      }
    },
    openSetSpecificDialog(status, item, index) {
      this.specificRuleDialog = {
        activate: true,
        status: status,
        item: item || new SpecificRule(),
        index: index,
      };
    },
    closeSetSpecificDialog() {
      this.specificRuleDialog = {
        activate: false,
        status: "new",
        item: {},
        index: 0,
      };
    },
    async setSpecificRule(rule) {
      try {
        // console.log(rule)
        await this.$store.dispatch("reservation/setSpecificRule", rule);
        this.closeSetSpecificDialog();
        this.getSpecifics();
        this.$L.alert("success", `操作成功`);
      } catch (e) {
        console.error(e);
        this.$L.alert("error", e.message);
        this.$refs.specificContent.stopLoading();
      }
    },
    async setPassRule(rule) {
      if (!rule.groupId || rule.groupId === "") {
        rule.groupId = this.data.obgrp.id;
      }
      try {
        await this.$store.dispatch("reservation/setRule", rule);
        this.closeSetRuleDialog();
        this.getRules();
        this.$L.alert("success", `操作成功`);
        this.$emit("refresh");
      } catch (e) {
        this.$L.alert("error", e.message);
        this.$refs.ruleContent.stopLoading();
      }
    },
    async findVehicleInGroup(searchValue) {
      try {
        let { items } = await this.getVehicles({
          pagination: {},
          search: searchValue,
        });
        return items;
      } catch (e) {
        this.$L.alert("error", e.message);
        return [];
      }
    },
    async deletePassRule(rule) {
      let { res, close } = await this.$L.confirm({
        title: "确认删除",
        text: "确认删除该规则？",
      });
      if (res) {
        try {
          await this.$store.dispatch("reservation/deleteRules", [rule]);
          this.getRules();
          this.$L.alert("success", "删除成功");
          this.$emit("refresh");
        } catch (e) {
          this.$L.alert("error", e.message);
        }
      }
      close();
    },
    async deleteSpecific(rule) {
      let { res, close } = await this.$L.confirm({
        title: "确认删除",
        text: "确认删除该规则？",
      });
      if (res) {
        try {
          await this.$store.dispatch("reservation/deleteRules", [rule]);
          this.getSpecifics();
          this.$L.alert("success", "删除成功");
        } catch (e) {
          this.$L.alert("error", e.message);
        }
      }
      close();
    },
    async getVehicles({ pagination, sortStack, filterItems = [], search }) {
      let res = await this.$store.dispatch("reservation/getVehicles", {
        group: this.data.obgrp,
        search: { key: "plate", value: search },
        sortStack: sortStack,
        pagination: pagination,
        filter: filterItems,
      });
      return res;
    },
    async getRules() {
      try {
        // Fixme 需要从页面上支持分页
        let { items } = await this.$store.dispatch("reservation/getRules", {
          groupId: this.data.obgrp.id,
          pagination: { page: 1, rowsPerPage: 100 },
        });
        console.log(items);
        this.data.rules = [];
        this.data.failureRules = [];
        console.log(items);
        for (let i = 0; i < items.length; i++) {
          let rule = items[i];
          if (rule.status === "-1") {
            this.passFairRules.push(rule);
            this.data.failureRules.push(rule);
          } else {
            this.passRules.push(rule);
            this.data.rules.push(rule);
          }
        }
      } catch (e) {
        console.error(e);
        this.$L.alert("error", e.message);
      }
    },
    async getSpecifics(initFlag = false) {
      if (initFlag) {
        this.page = 1;
      }
      try {
        // Fixme 需要从页面上支持分页
        let { items, amount } = await this.$store.dispatch(
          "reservation/getAllSpecifics",
          {
            group: this.data.obgrp,
            search: this.search,
            pagination: { page: this.page, rowsPerPage: this.pageSize },
          }
        );
        this.data.specifics = items;
        this.specificalRules = items;
        this.totalPage = Math.ceil(amount / this.pageSize);
      } catch (e) {
        this.$L.alert("error", e.message);
      }
    },
    addVehicle() {
      console.log(this.data);
      this.$router.push({
        name: "NewGroupReservation",
        query: {
          status: "addVehicle",
          id: this.data.obgrp.id,
        },
      });
    },
    goDetails(item) {
      console.log(item);
      let selectionString = document.getSelection().toString();
      if (!selectionString) {
        this.$router.push({
          name: "VehicleStatisticDetails",
          params: {
            plate: item.plate,
          },
        });
      }
    },
    isOverDate(v) {
      let date = new Date();
      if (v < date.getTime()) {
        this.overdateFlag = true;
      } else {
        this.overdateFlag = false;
      }
    },
    async deleteVehicle(item) {
      let { res, close } = await this.$L.confirm({
        title: "提示",
        text: "您确定要删除该车辆，车牌号码：" + item.plate,
      });
      if (res) {
        try {
          let ids = [];
          ids.push(item.id);
          let res = await this.$store.dispatch("reservation/deleteVehicles", {
            ids: ids,
            force: "false",
          });
          console.log(res);
          if (res.data.status === 1) {
            let data = res.data.data;
            if (data.fail !== 0) {
              this.deleteFailArr = data.failIdArr;
              this.deleteFailArrItems = [];
              for (let i = 0; i < data.failObjectArr.length; i++) {
                this.deleteFailArrItems.push({ plate: data.failObjectArr[i] });
              }
              this.deleteFailDialog.activated = true;
            } else {
              this.$L.alert("success", { message: "删除成功" });
              this.$refs.vehicleTable.refresh();
            }
          } else {
            this.$L.alert("error", {
              message: "删除失败，原因：" + res.data.msg,
            });
          }
        } catch (e) {
          this.$L.alert("error", e.message);
        }
      }
      close();
    },
    async deleteVehicleForce() {
      try {
        this.deleteFailDialog.loading = true;
        let res = await this.$store.dispatch("reservation/deleteVehicles", {
          ids: this.deleteFailArr,
          force: "true",
        });
        if (res.data.status === 1) {
          this.$L.alert("success", { message: "删除成功" });
          this.$refs.vehicleTable.refresh();
          this.deleteFailDialog.activated = false;
        } else {
          this.$L.alert("error", {
            message: "删除失败，原因：" + res.data.msg,
          });
        }
      } catch (e) {
        this.$L.alert("error", { message: "发生异常，原因：" + e.toString() });
      } finally {
        this.deleteFailDialog.loading = false;
      }
    },
    dealExtend() {
      try {
        if (this.data.obgrp.extend !== null) {
          let extend = JSON.parse(this.data.obgrp.extend);
          if (extend.qrcodePath !== undefined) {
            this.selfSignInfo.selfSignUrl = "/qrcode" + extend.qrcodePath;
            this.selfSignInfo.comment = extend.comment;
            this.selfSignInfo.total = extend.total;
            this.selfSignInfo.perDay = extend.perDay;
          }
        }
      } catch (e) {
        return;
      }
    },
  },
  activated() {
    console.log(this.tab);
    if (this.$L.tab.currentTab && !this.$L.tab.currentTab.desc) {
      this.$L.tab.set(this.$L.tab.current, { desc: this.data.obgrp.name });
    }
    console.log("activated", this.data);
  },
  created() {
    //console.log(this.data)
    this.tab = this.tabProp;
    if (this.data.obgrp.rhdata !== undefined) {
      let status = JSON.parse(this.data.obgrp.rhdata).r_h_status;
      this.data.obgrp.status = status + "";
    } else {
      this.data.obgrp.status = "-1";
    }
    if (this.$L.tab.currentTab && !this.$L.tab.currentTab.desc) {
      this.$L.tab.set(this.$L.tab.current, { desc: this.data.obgrp.name });
    }
    this.dealExtend();
    this.getRules();
    this.getSpecifics();
    this.isOverDate(time.toTimeStamp(this.data.obgrp.expirationTime));
  },
};
</script>

<style scoped>
</style>
